// ============================================================
//  src/components/Contact/Contact.jsx
// ============================================================

import React from "react";
import { Link } from "react-router-dom";
import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact-page">

      {/* ── HERO ── */}
      <section className="ct-hero">
        <div className="ct-hero__img" />
        <div className="ct-hero__overlay" />

        <div className="ct-hero__content">
          <div>
            <div className="ct-hero__eyebrow">Get in Touch</div>
            <h1 className="ct-hero__title">
              Let's Tell<br />Your <em>Story.</em>
            </h1>
          </div>
          <p className="ct-hero__quote">
            "Every love story deserves to be told with honesty, beauty, and a little bit of magic."
          </p>
        </div>

        <div className="ct-scroll-hint">
          <div className="ct-scroll-line" />
          <span>Scroll</span>
        </div>
      </section>

      {/* ── CONTACT INFO ── */}
      <section className="ct-section">

        {/* Header */}
        <div className="ct-section__top">
          <div>
            <div className="ct-eyebrow">Contact Us</div>
            <h2 className="ct-heading">
              We'd Love to<br />Hear From You
            </h2>
          </div>
          <p className="ct-desc">
            Whether you're planning a wedding, a baby shoot, or a family portrait — reach out and let's create something beautiful together.
          </p>
        </div>

        {/* 4 Cards */}
        <div className="ct-cards">

          <div className="ct-card">
            <div className="ct-card__icon">📞</div>
            <div className="ct-card__label">Call Us</div>
            <div className="ct-card__title">Phone</div>
            <a href="tel:+918940639672" className="ct-card__value">+91 89406 39672</a>
            <a href="tel:+919600998798" className="ct-card__value" style={{ marginTop: 6 }}>+91 96009 98798</a>
          </div>

          <div className="ct-card">
            <div className="ct-card__icon">💬</div>
            <div className="ct-card__label">Chat with Us</div>
            <div className="ct-card__title">WhatsApp</div>
            <a href="https://wa.me/919600998798" className="ct-card__value" target="_blank" rel="noopener noreferrer">
              +91 96009 98798<br />Tap to open WhatsApp →
            </a>
          </div>

          <div className="ct-card">
            <div className="ct-card__icon">✉️</div>
            <div className="ct-card__label">Write to Us</div>
            <div className="ct-card__title">Email</div>
            <a href="mailto:info@brandpartners.in" className="ct-card__value">info@brandpartners.in</a>
          </div>

          <div className="ct-card">
            <div className="ct-card__icon">📍</div>
            <div className="ct-card__label">Visit Us</div>
            <div className="ct-card__title">Studio Address</div>
            <span className="ct-card__value">
              1A Cave Street, Duthi School Road<br />
              Nagercoil, Kanyakumari – 629 001
            </span>
          </div>

        </div>

        {/* Bottom Row */}
        <div className="ct-bottom">

          {/* Map */}
          <a
            className="ct-map"
            href="https://www.google.com/maps/search/1A+Cave+Street+Duthi+School+Road+Nagercoil+Tamil+Nadu+629001"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="ct-map__inner">
              <div className="ct-map__pin">📍</div>
              <div className="ct-map__name">Brand Partner Studio</div>
              <div className="ct-map__addr">1A Cave Street, Nagercoil – 629 001</div>
            </div>
            <span className="ct-map__hint">Open in Maps →</span>
          </a>

          {/* Social + Hours */}
          <div className="ct-social-hours">

            <div>
              <div className="ct-sub-label">Follow Our Work</div>
              <div className="ct-social-links">
                <a
                  className="ct-social-link"
                  href="https://www.instagram.com/brandpartnersphotography/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram ↗
                </a>
                <a className="ct-social-link" href="#" target="_blank" rel="noopener noreferrer">
                  Facebook ↗
                </a>
              </div>
            </div>

            <div>
              <div className="ct-sub-label">Studio Hours</div>
              <div className="ct-hours">
                <div className="ct-hour-row">
                  <span>Monday – Saturday</span>
                  <span>9:00 AM – 7:00 PM</span>
                </div>
                <div className="ct-hour-row">
                  <span>Sunday</span>
                  <span>By Appointment</span>
                </div>
                <div className="ct-hour-row">
                  <span>WhatsApp</span>
                  <span>Always Available</span>
                </div>
              </div>
            </div>

          </div>
        </div>

      </section>
    </div>
  );
};

export default Contact;